import {
  LayoutDashboard,
  Compass,
  Activity,
  History,
  Trophy,
  Settings,
  Users,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  title: string;
  href: string;
  icon: LucideIcon;
  /** If set, only users with this role see the item. */
  requiredRole?: 'ADMIN';
}

export const mainNavItems: NavItem[] = [
  {
    title: 'Dashboard',
    href: '/dashboard',
    icon: LayoutDashboard,
  },
  {
    title: 'Markets arena',
    href: '/markets',
    icon: Compass,
  },
  {
    title: '30s live arena',
    href: '/arena',
    icon: Activity,
  },
  {
    title: 'My predictions',
    href: '/my-predictions',
    icon: History,
  },
  {
    title: 'Leaderboard',
    href: '/leaderboard',
    icon: Trophy,
  },
  {
    title: 'Profile settings',
    href: '/settings/profile',
    icon: Settings,
  },
];

export const adminNavItems: NavItem[] = [
  {
    title: 'Admin users',
    href: '/admin/users',
    icon: Users,
    requiredRole: 'ADMIN',
  },
];
